import React, {ReactNode, useCallback, useEffect, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {flow, identity} from 'lodash';
import {useQueryErrorResetBoundary} from '@tanstack/react-query';
import {Exception, getQueryClient} from 'helpers';
import * as ReactErrorBoundary from 'react-error-boundary';

interface Props {
  children: ReactNode;
  wrap?: (content: ReactNode) => ReactNode;
}

export const ErrorBoundary = ({children, wrap = identity}: Props) => (
  <ReactErrorBoundary.ErrorBoundary
    FallbackComponent={useMemo(() => flow(ErrorMessage, wrap), [])}
    children={children}
  />
);

export const ErrorMessage = ({error, resetErrorBoundary}: ReactErrorBoundary.FallbackProps) => {
  const history = useHistory();
  const queryErrorResetBoundary = useQueryErrorResetBoundary();
  const reset = useCallback(() => {
    queryErrorResetBoundary.reset();
    resetErrorBoundary();
    getQueryClient().removeQueries({
      predicate: (state) => !!state.state.error
    })
  }, []);
  useEffect(() => history.listen(reset), []);
  useEffect(() => reset, []);
  const {title, message} = error instanceof Exception ? error : {}
  return (
    <>
      <h3>{title ?? 'Something went wrong.'}</h3>
      <p>{message ?? 'We are already working on solving this. Please try again later.'}</p>
    </>
  );
}
